import React, { useState, useRef, useEffect } from 'react';

import _ from 'lodash';
import { Accordion, Alert, Card } from 'react-bootstrap';
import { ChevronDown } from 'react-bootstrap-icons';

import { Number } from '../../common/common';

import './steptwo.component.css';
import Loader from '../../common/loader/loader.component';

const StepTwo = (props) => {
  const containerRef = useRef(null);

  const getOffer = (tx) => {
    if (tx.type === 'BONUS' || tx.type === 'SPLIT') {
      return `${tx.ratio_1}:${tx.ratio_2}`;
    } else if (tx.type === 'DIVIDEND') {
      return `₹${tx.ratio_3} per share`;
    } else {
      return '-';
    }
  };

  return (
    <div
      ref={containerRef}
      className="add-tx-content px-md-5 pt-md-5 px-sm-4 pt-sm-4 px-4 pt-4"
    >
      <div className="add-tx-header">
        <span className="step-text">{props.pfName}</span>
        {!props.isMobile ? (
          <h5 className="step-heading pt-1">VIEW ADDED TRANSACTIONS</h5>
        ) : (
          <h5 className="step-heading pt-1">VIEW ADDED TRANSACTION</h5>
        )}
        <span className="step-info">
          Data includes all corporate actions such as bonus & split amounts into
          the portfolio
        </span>
      </div>
      <Alert variant={'danger'} show={props.showError}>
        {props.errorMessage}
      </Alert>
      <div id="transactions" className="mt-3 position-relative flex-grow">
        {props.isLoaderVisible ? (
          <div className="overlay-loader-cont">
            <Loader />
          </div>
        ) : null}
        <div className="h-100 overflow-auto">
          {props.txs &&
            props.txs.map((ctxs, idx_comp) =>
              ctxs.proceed ? (
                <Accordion
                  className="company-accordion mt-2"
                  key={'acc-' + idx_comp}
                >
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey={'c-' + idx_comp}
                      className="no-bg"
                    >
                      <b>{ctxs.company.name}</b>
                      <span>
                        <span className="pr-2">
                          Total Cost:{' '}
                          <span style={{ fontWeight: 500 }}>
                            <Number
                              value={Math.abs(ctxs.amount)}
                              usePrefix={true}
                            />
                          </span>
                        </span>
                        <span className="pull-right">
                          <ChevronDown />
                        </span>
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={'c-' + idx_comp}>
                      <Card.Body className="accordion-body">
                        <table className="view-tx-table table-responsive">
                          <tbody className="table-body">
                            <tr>
                              <th className="pl-3 pr-3">Transaction Date</th>
                              <th className="pl-3 pr-3">Type</th>
                              <th className="pl-3 pr-3 text-right">Shares</th>
                              <th className="pl-3 pr-3 text-right">Price</th>
                              <th className="pl-3 pr-3 text-right">Offer</th>
                              <th className="pl-3 pr-3 text-right">Amount</th>
                              <th className="pl-3 pr-3 text-right">
                                Balance Shares
                              </th>
                            </tr>
                            {ctxs.transactions &&
                              [...ctxs.transactions]
                                .reverse()
                                .map((tx, idx_tx) => (
                                  <tr className="table-row" key={'t-' + idx_tx}>
                                    <td className="px-3 py-2">{tx.date}</td>
                                    <td className="px-3 py-2 text-capitalize">
                                      {tx.type.toLowerCase()}
                                    </td>
                                    <td className="px-3 py-2 text-right">
                                      {tx.shares}
                                    </td>
                                    <td className="px-3 py-2 text-right">
                                      {tx.price}
                                    </td>
                                    <td className="px-3 py-2 text-right">
                                      {getOffer(tx)}
                                    </td>
                                    <td className="px-3 py-2 text-right">
                                      <Number
                                        value={Math.abs(tx.amount)}
                                        usePrefix={true}
                                      />
                                    </td>
                                    <td className="px-3 py-2 text-right">
                                      {tx.balance ? Math.abs(tx.balance) : ''}
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              ) : (
                <Accordion
                  className="company-accordion mt-2"
                  key={'acc-' + idx_comp}
                >
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey={'c-' + idx_comp}
                      className="no-bg"
                    >
                      <b>{ctxs.company.name}</b>
                      <span className="pull-right">
                        Transactions already exists in portfolio
                      </span>
                    </Accordion.Toggle>
                  </Card>
                </Accordion>
              ),
            )}
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
